import React, { useEffect, useState } from 'react';
import { LoadingSVG, MessageText, ModalBackdrop, ModalContainer, ModalContent, SpinnerContainer } from './LoadingModal.styles';

// Types
export interface LoadingModalProps {
  visible: boolean;
  message?: string;
  defaultMessage: string;
}

// Main Component
export const LoadingModal: React.FC<LoadingModalProps> = ({
  visible,
  message,
  defaultMessage,
}) => {
  // Using portal approach - add root element if not exists
  const [portalRoot, setPortalRoot] = useState<HTMLElement | null>(null);

  useEffect(() => {
    let root = document.getElementById('modal-root');
    if (!root) {
      root = document.createElement('div');
      root.id = 'modal-root';
      document.body.appendChild(root);
    }
    setPortalRoot(root);

    // Cleanup
    return () => {
      // Only attempt to remove if root exists AND is a child of document.body
      if (root && document.body.contains(root) && root.childNodes.length === 0) {
        try {
          document.body.removeChild(root);
        } catch (error) {}
      }
    };
  }, []);

  // Handle body scroll when modal is visible
  useEffect(() => {
    if (visible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [visible]);

  if (!portalRoot) return null;

  // Using ReactDOM.createPortal equivalent approach with styled components
  return (
    <ModalBackdrop $visible={visible}>
      <ModalContainer>
        <ModalContent>
          <SpinnerContainer>
            <LoadingSVG />
          </SpinnerContainer>
          <MessageText>
            {message || defaultMessage}
          </MessageText>
        </ModalContent>
      </ModalContainer>
    </ModalBackdrop>
  );
};

LoadingModal.displayName = 'LoadingModal';

export default LoadingModal;
